export const MAPPING_HEADER_COPY = {
  cardLabel: "Mapping",
  productLabel: "Product",
  productPlaceholder: "Select a product",
  productFallbackLabel: "Product",
  versionLabel: "Version",
  climateImpactLabel: "Climate Change Impact",
  pending: "Pending",
  pendingTooltip: "Available once the first calculation completes",
  viewSummary: "View the full result in Product Summary",
  defaultImpactUnit: "kgCO₂eq",
  collapse: "Shrink",
  expand: "Expand",
  hideDetails: "Hide version & climate change impact",
  showDetails: "Show version & climate change impact"
} as const;
